const contactFormBtn = document.querySelector('[data-contact-form-submit]');
if (contactFormBtn) {
  const successForm = document.querySelector(
    '[data-modal-content="quoteSuccess"]'
  );
  successForm.classList.add('contact-version');
}
const successQuote = getUrlParameter('contact_posted');
const isCustomerForm = getUrlParameter('customer_posted');
const isBIS = getUrlHash('BISForm');

if (successQuote) {
  const modal = 'offerSuccess';
  modalPop(modal);
  const successModalContent = document.querySelector(
    `[data-modal-content="${modal}"]`
  );
  const title = localStorage.getItem('quoteProduct');
  const imageSrc = localStorage.getItem('quoteImageSrc');
  const imageSrcset = localStorage.getItem('quoteImageSrcset');
  console.log('LOCAL STORAGE', title, imageSrc, imageSrcset);
  if (imageSrc) {
    successModalContent.querySelector('[data-product-image] img').src =
      imageSrc;
    successModalContent.querySelector('[data-product-image] img').srcset =
      imageSrcset;
    successModalContent.querySelector('[data-quote-display-title]').innerHTML =
      title;
  } else {
    successModalContent
      .querySelector('[data-product-image]')
      .classList.add('hide');
  }
}

if (isCustomerForm && isBIS) {
  modalPop('bisSuccess');
}
